/*--------------------------------------------------------------
# Custom scripts for Hero carousel block
--------------------------------------------------------------*/

const heroSlider = document.querySelectorAll('.hero-slider-block .swiper');
const heroSliderNext = document.querySelectorAll('.hero-swiper-next');
const heroSliderPrev = document.querySelectorAll('.hero-swiper-prev');
const playPauseButtons = document.querySelectorAll('.slider-control');

for( let i = 0; i < heroSlider.length; i++ ) {
    // Add a dynamic class to every instance of the slider
    heroSlider[i].classList.add('swiper-' + i);
    heroSliderNext[i].classList.add('hero-swiper-next-' + i);
    heroSliderPrev[i].classList.add('hero-swiper-prev-' + i);
    playPauseButtons[i].dataset.sliderId = 'swiper-' + i;

    // Initialize Swiper with navigation arrows and autoplay settings
    let initHeroSlider = new Swiper('.hero-slider-block .swiper-' + i, {
        grabCursor: false,
        simulateTouch: false,
        slidesPerView: 1,
        loop: true,
		speed: 1000,
        autoHeight: false,
        autoplay: {
            delay: 16000, // 16 seconds delay
            disableOnInteraction: false // Autoplay continues even after interacting with the slider
        },
        navigation: {
            nextEl: '.hero-swiper-next-' + i,
            prevEl: '.hero-swiper-prev-' + i,
        }
    });

    // Check if the next or prev buttons have the locked class
    if(heroSliderPrev[i].classList.contains('swiper-button-lock') || heroSliderNext[i].classList.contains('swiper-button-lock')) {
        // Hide the play/pause button if there's only one slide
        playPauseButtons[i].style.display = 'none';
    }

    // Add event listener for the play/pause button
    playPauseButtons[i].addEventListener('click', function() {
        const icon = this.querySelector('.play-pause-icon');
        const text = this.querySelector('.play-pause-text');

        if (initHeroSlider.autoplay.running) {
            initHeroSlider.autoplay.stop();
            icon.classList.remove('icon-pause');
            icon.classList.add('icon-play-outline');
            text.textContent = 'Play sliders';
        } else {
            initHeroSlider.autoplay.start();
            icon.classList.remove('icon-play-outline');
            icon.classList.add('icon-pause');
            text.textContent = 'Pause sliders';
        }
    });
} 